// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Form, FormGroup, Row, Col, FormControl, Button, ControlLabel, Clearfix, Alert, Checkbox } from 'react-bootstrap'
import { Link } from 'react-router'
import config from '../config/config.json'

export class Login extends Component {
    constructor(props) {
        super(props)

        this.init()

        this.state = {
            formAlertType: 'danger',
            formAlertDisplay: 'none',
            formAlertText: '',
            showPassword: false
        }

        this.init = this.init.bind(this)
        this.handleShowPassword = this.handleShowPassword.bind(this)
        this.handleOnSubmit = this.handleOnSubmit.bind(this)
        this.loginUser = this.loginUser.bind(this)
        this.formAlertUpdate = this.formAlertUpdate.bind(this)
        this.handlePostLoginData = this.handlePostLoginData.bind(this)
    }

    /**
     * Set the state of alerts. It takes 3 parameters:
     *	type: type of alert 
     *		'danger'	-> turns the alert red for errors, 
     *		'success'	-> turns the alert green for success, 
     *		'warning'	-> turns the alert amber for warnings)
     *	display: handles the visibility of the display section 
     *		'block' -> for visbility
     *		'none'	-> for hidden
     *	text: the alert message to be displayed
    **/
    formAlertUpdate(type, display, text) {
        this.setState({
            formAlertType: type,
            formAlertDisplay: display,
            formAlertText: text
        })
    }

    init() {
        if (window.sessionStorage.getItem('authToken')) {
            console.log("logged in")
            if (window.sessionStorage.getItem('profileType') === 'provider') {
                this.props.router.push('/workforce')
            }
            else {
                this.props.router.push('/individual')
            }

        }

        if (typeof this.props.location.query.confirmed !== 'undefined' && this.props.location.query.confirmed) {
            this.formAlertUpdate('success', 'block', 'Your account has been created Successfully!')
        }
    }

    handleShowPassword(e) {
        this.setState({
            showPassword: e.target.checked
        })
    }

    /**
        This function handles the submission of the login form.
        Based on the profile type, this function will call the respective APIs to login service providers or support workers
    **/
    handleOnSubmit(e) {
        e.preventDefault()

        let formData = {
            email: this.emailInput.value,
            password: this.passwordInput.value,
        }

        this.loginUser(formData, this.props.env, config)

    }

    loginUser(formData, env, config) {
        fetch(config[env] + config.api.login.endpoint, {
            method: config.api.login.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'email': formData.email,
                'password': formData.password
            })
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.error) {
                    this.formAlertUpdate('danger', 'block', responseJson.error)
                } else {
                    this.getAllModules(this.props.env, config, responseJson, formData.email)
                }
            })
            .catch((error) => {
                console.error(error);
                this.formAlertUpdate('danger', 'block', 'error')
            })
    }

    getAllModules(env, config, loginData, email) {
        fetch(config[env] + config.api.all_modules.endpoint, {
            method: config.api.all_modules.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                this.props.handleGlobalModuleData(responseJson)
                this.handlePostLoginData(loginData, email)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    handlePostLoginData(data, email) {
        let redirectRoute = this.props.location.query.redirect

        if ('provider' in data) {
            this.props.handleLoginStateChange(true)
            this.props.handleAuthToken(data.auth_token)
            this.props.handleEmail(email)
            this.props.handleSetProfileType('provider')
            this.props.handleProviderDataUpdate(data.provider)

            if (redirectRoute) {
                this.props.router.push(redirectRoute)
            } else {
                this.props.router.push('/workforce')
            }
        }
        else if ('worker' in data) {
            if (!data.worker.confirmed) {
                this.formAlertUpdate('danger', 'block', 'Please activate your account before logging in')
                return
            }
            this.props.handleLoginStateChange(true)
            this.props.handleAuthToken(data.auth_token)
            this.props.handleEmail(email)
            this.props.handleSetProfileType('worker')
            this.props.handleWorkerDataUpdate(data.worker)

            if (redirectRoute) {
                this.props.router.push(redirectRoute)
            } else {
                this.props.router.push('/individual')
            }
        }
    }

    render() {
        return (
            <div className="login-container page-container">
                <div className="banner">
                    <Col smOffset={2} sm={8}>
                        <h2 className="title">Login</h2>
                        <p className="sub-heading">Welcome to Enabler Interactive</p>
                    </Col>
                    <Clearfix />
                </div>
                <Row>
                    <Col sm={12}>
                        <Alert bsStyle={this.state.formAlertType} style={{ display: this.state.formAlertDisplay }} onDismiss={this.handleAlertDismiss}>
                            <h3>{this.state.formAlertType === 'danger' ? "Login Unsuccessful!" : "Success"}</h3>
                            <p className="alert-text">{this.state.formAlertText}</p>
                        </Alert>
                    </Col>
                </Row>
                <Form horizontal className="login-form">
                    <FormGroup controlId="formHorizontalEmail">
                        <Col componentClass={ControlLabel} sm={4}>
                            Email
                        </Col>
                        <Col sm={5}>
                            <FormControl type="email" placeholder="Email" autoComplete="email" inputRef={ref => { this.emailInput = ref }} />
                            <FormControl.Feedback />
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="formHorizontalPassword">
                        <Col componentClass={ControlLabel} sm={4}>
                            Password
                        </Col>
                        <Col sm={5}>
                            <FormControl type={this.state.showPassword ? "text" : "password"} placeholder="Password" autoComplete="current-password"
                                inputRef={ref => { this.passwordInput = ref }} />
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="formHorizontalShowPassword">
                        <Col smOffset={4} sm={5}>
                            <Checkbox onChange={this.handleShowPassword} >
                                Show Password
                            </Checkbox>
                        </Col>
                    </FormGroup>
                    <hr className="invisible post-form" />
                    <FormGroup>
                        <Col smOffset={4} sm={5}>
                            <Button type="submit" bsStyle="primary" onClick={this.handleOnSubmit}>
                                Login
                            </Button>

                        </Col>
                        <Col sm={2}>

                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col smOffset={4} >
                            <span className="add-opts">
                                <Link to='/register'>Create Account</Link>|
                                <Link to='/forgotPassword'>Forgot Password?</Link>
                            </span>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/login.js